import { ConfigService } from '../../../../services';
import { CustomerConfig } from '../../../../dto/customer-config';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OnInit, Component } from '@angular/core';
import { CustomerEmailTemplatesService } from '../../../services/customer-email-templates.service';
import { EmailTemplate } from '../../../../dto/templates/email-template';

@Component({
  selector: 'app-customer-config',
  templateUrl: './customer-config.component.html',
  styleUrls: ['./customer-config.component.css']
})
export class CustomerConfigComponent implements OnInit {
  emailTemplates: EmailTemplate[];

  constructor(
    private configService: ConfigService,
    private formBuilder: FormBuilder,
    private emailTemplatesService: CustomerEmailTemplatesService,
  ) { }

  configForm: FormGroup;

  ngOnInit() {
    this.emailTemplatesService.getMany().subscribe(result => {
      this.emailTemplates = result.data;
      this.configService.getCustomerConfig().subscribe(data => {
        this.initForm(data);
      });
    });
  }

  initForm(value: CustomerConfig = null) {
    if (value != null) {
      this.configForm = this.formBuilder.group({
        idvTemplateId:                    value.idvTemplateId,
        docsTemplateId:                   value.docsTemplateId,
        sofGenericTemplateId:             value.sofGenericTemplateId,
        sofGenericSuccessTemplateId:      value.sofGenericSuccessTemplateId,
        sofGenericFailedTemplateId:       value.sofGenericFailedTemplateId,
        sofSingleTemplateId:              value.sofSingleTemplateId,
        sofSingleSuccessTemplateId:       value.sofSingleSuccessTemplateId,
        sofSingleFailedTemplateId:        value.sofSingleFailedTemplateId,
        addressChangeTemplateId:          value.addressChangeTemplateId,
        addressConfirmTemplateId:         value.addressConfirmTemplateId,
        idvSuccessTemplateId:             value.idvSuccessTemplateId,
        idvFailedTemplateId:              value.idvFailedTemplateId,
        docsSuccessTemplateId:            value.docsSuccessTemplateId,
        docsFailedTemplateId:             value.docsFailedTemplateId,
        sepaImportTemplateId:             value.sepaImportTemplateId,
        docsPaymentTemplateId:            value.docsPaymentTemplateId,
        changeEmailTemplateId:            value.changeEmailTemplateId,
      customerIdentTemplateId:            value.customerIdentTemplateId,
        addressSuccessTemplateId:         value.addressSuccessTemplateId,
        addressFailedTemplateId:          value.addressFailedTemplateId,
        btlSuccessLoadTemplateId:         value.btlSuccessLoadTemplateId,
        btlSuccessPartialLoadTemplateId:  value.btlSuccessPartialLoadTemplateId,
        btlPendingLoadTemplateId:         value.btlPendingLoadTemplateId,
        btlWebIdLoadTemplateId:           value.btlWebIdLoadTemplateId,
        btlDocLoadTemplateId:             value.btlDocLoadTemplateId,
        btlDeclinedLoadTemplateId:        value.btlDeclinedLoadTemplateId,
        btlPendingBelowMinLoadTemplateId: value.btlPendingBelowMinLoadTemplateId,
        revocationConfirmationTemplateId: value.revocationConfirmationTemplateId,
        firstBtlCompletedTemplateId:      value.firstBtlCompletedTemplateId,
        cardsLockedInvoiceOverdueTemplateId: value.cardsLockedInvoiceOverdueTemplateId,
        reorderPendingUnpaidInvoiceTemplateId: value.reorderPendingUnpaidInvoiceTemplateId,
        reorderPendingNoIdentTemplateId: value.reorderPendingNoIdentTemplateId,
        reorderPendingAddressUnconfirmedTemplateId: value.reorderPendingAddressUnconfirmedTemplateId,
        happyBirthdayTemplateId: value.happyBirthdayTemplateId,
        emailConfirmationTemplateId: value.emailConfirmationTemplateId,
        emailChangeTemplateId: value.emailChangeTemplateId,

      });
    }
    this.configForm.markAsPristine();
  }

  onSubmit(form: FormGroup) {
    this.configService.setCustomerConfig(form.value).subscribe(result => {
      this.initForm();
    });
  }
}
